import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function ListSkeleton({ rows = 4 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 p-4 rounded-2xl bg-white border border-slate-200">
          <Skeleton className="w-11 h-11 rounded-full" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
          <Skeleton className="h-4 w-16" />
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="p-6 rounded-3xl bg-white border border-slate-200 space-y-4">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-10 w-1/2" />
      <Skeleton className="h-3 w-2/3" />
    </div>
  );
}
